module.exports = __webpack_public_path__ + "img/vector_white.88bb7e3e.svg";